// src/utils/websocket.ts

let socket: WebSocket | null = null;
let reconnectAttempts = 0;
const MAX_RETRIES = 5;
const RECONNECT_DELAY_MS = 3000;
const rawUrl = "https://api.smartwiz.link";

if (!rawUrl) {
  console.warn(
    "[WebSocket] ⚠️ VITE_BACKEND_URL is not defined. WebSocket connection will not be established."
  );
}

const WEBSOCKET_URL = (rawUrl ?? "").replace(/^https?:\/\//, "");

console.log("[WebSocket] WebSocket URL: ", WEBSOCKET_URL);

/**
 * Establish and return the notification WebSocket connection.
 * Automatically reconnects on unexpected disconnect.
 *
 */
export function getNotificationSocket(
  onMessage?: (data: any) => void
): WebSocket {
  if (
    !socket ||
    socket.readyState === WebSocket.CLOSED ||
    socket.readyState === WebSocket.CLOSING
  ) {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";

    // Get authentication token from cookies
    let tokenParam = "";
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split("=");
      if (name === "access_token" && value) {
        tokenParam = `?token=${encodeURIComponent(value)}`;
        break;
      }
    }

    const socketUrl = `${protocol}://${WEBSOCKET_URL}/ws/notifications/${tokenParam}`;
    console.log("[WebSocket] Connecting with auth token:", !!tokenParam);
    socket = new WebSocket(socketUrl);

    socket.onopen = () => {
      reconnectAttempts = 0;
      console.info("[WebSocket] Connected to notifications");
    };

    socket.onmessage = (event: MessageEvent) => {
      if (onMessage) {
        try {
          const data = JSON.parse(event.data);
          onMessage(data);
        } catch (err) {
          console.error("[WebSocket] Failed to parse message:", err);
        }
      }
    };

    socket.onclose = (event) => {
      console.warn("[WebSocket] Connection closed", event);
      if (!event.wasClean && reconnectAttempts < MAX_RETRIES) {
        setTimeout(() => {
          reconnectAttempts++;
          getNotificationSocket(onMessage);
        }, RECONNECT_DELAY_MS);
      }
    };

    socket.onerror = (error) => {
      console.error("[WebSocket] Error occurred", error);
      socket?.close();
    };
  }

  return socket;
}

/**
 * Cleanly disconnect the WebSocket connection.
 */
export function disconnectNotificationSocket(): void {
  if (socket) {
    console.info("[WebSocket] Closing socket...");
    console.log("socket", socket);
    socket.close(1000, "Client initiated close");
  }
  socket = null;
}
